import { useEffect } from "react";

const popularSeries = [
  {
    title: "超初心者向けシリーズ",
    desc: "数ある初心者用動画はあれど、激烈に初心者向けの動画はここだけのはず。ほぼ初心者が教える、初心者目線の解説動画。",
    tag: "#初心者",
    tagColor: "bg-[#0066FF]",
    img: "https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/a83e238d6147cdf763df639485f63c8a.png",
    rotate: "-rotate-2",
    borderColor: "border-[#FFD700]",
    url: "https://youtube.com/playlist?list=PLEvleHvb7Eg-yCdzSilUy6X_sh4aIggpi&si=l_f_adWa8RwqpURz",
  },
  {
    title: "長距離シリーズ",
    desc: "トラックドライバーの醍醐味、長距離運行の動画。（中距離との指摘も）運送業のリアルをお届け。",
    tag: "#長距離",
    tagColor: "bg-[#0066FF]",
    img: "https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/f3c509b7034404a62606452e2d4f4480.png",
    rotate: "rotate-2",
    borderColor: "border-[#FFD700]",
    url: "https://youtube.com/playlist?list=PLEvleHvb7Eg-HzwyKcRxQx02cb4WyDybI&si=FZVMkWH-ajv_P9PE",
  },
  {
    title: "あるある歌シリーズ",
    desc: "トラックドライバーが感じてしまう、色んなあるあるを素敵なメロディーとMVに乗せて♪",
    tag: "#あるある",
    tagColor: "bg-[#0066FF]",
    img: "https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/df1ccd559fae0a2c23838d46c963b06e.png",
    rotate: "-rotate-1",
    borderColor: "border-[#FFD700]",
    url: "https://youtube.com/playlist?list=PLEvleHvb7Eg-hUj-BtE0HP_6LRTXJOqUT&si=8pE62uHAkuoiESAx",
  },
];

const recommendedSeries = [
  {
    title: "転職シリーズ",
    desc: "他業種から運送業へ転職してきたドライバーさん達にインタビュー。前職との比較や、実際に運送業で働いてみてどう感じてるかのリアルな声をどうぞ！",
    tag: "#転職",
    tagColor: "bg-[#00B050]",
    img: "https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/d059910994dc70784e9f629f6f840303.png",
    rotate: "rotate-1",
    borderColor: "border-[#00B050]",
    url: "https://youtube.com/playlist?list=PLEvleHvb7Eg_3UOKczZgYgB_0wl0QuKyo&si=kTvvwkRg7GvZf9h3",
  },
  {
    title: "社内イベント",
    desc: "どこに就職しても必ずあるであろう飲み会やバーベキュー。これを見ておけば雰囲気がよくわかります。だけど、安心して！行くか行かないかは自由です！",
    tag: "#イベント",
    tagColor: "bg-[#00B050]",
    img: "https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/221f4c8489145fe08ea9796641079203.jpeg",
    rotate: "-rotate-2",
    borderColor: "border-[#00B050]",
    url: "https://youtube.com/playlist?list=PLEvleHvb7Eg-hsU9hmVnFq7xslTWlh7bz&si=cVg9HquJe5gXFQ-_",
  },
  {
    title: "ラジオ",
    desc: "運転中にYouTube見るのはダメだけど、聞くのはいいよねという事で始めたラジオ企画。毎週朝8時更新。運行のお供にどうぞ！",
    tag: "#毎週更新",
    tagColor: "bg-[#00B050]",
    img: "https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/7f5a18de0a92799295fb0c2c59c03e60.jpeg",
    rotate: "rotate-2",
    borderColor: "border-[#00B050]",
    url: "https://youtube.com/playlist?list=PLEvleHvb7Eg9--jYE6KTjGCkcStBBRY3a&si=d5Gx1RD3PkabWH3D",
  },
];

const entertSeries = [
  {
    title: "雑談トークシリーズ",
    desc: "運行後や休憩中にドライバー達が喋ってる動画。男女の話題から、ラーメンの汁を全部飲むか飲まないかなど、どうでもいい話ばかり。",
    tag: "#どうでもいい",
    tagColor: "bg-[#FFD700]",
    img: "https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/64f87765a5d3334b74c83aaa283bca61.png",
    rotate: "-rotate-1",
    borderColor: "border-[#FFD700]",
    url: "https://youtube.com/playlist?list=PLEvleHvb7Eg_MnS4oc0XoEwBLzuM_BqnK&si=7j6e7I4Z_AxEe2DT",
  },

  {
    title: "さくやくんシリーズ",
    desc: "彼女いない暦 = 年齢のさくやくんに何とかして彼女を作ろうと奮闘するシリーズ。難航中…。アイデア求む。",
    tag: "#恋愛",
    tagColor: "bg-[#FFD700]",
    img: "https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/c378ba74d56d58e2ba6912831d54dd46.jpeg",
    rotate: "rotate-1",
    borderColor: "border-[#FFD700]",
    url: "https://youtube.com/playlist?list=PLEvleHvb7Eg_SkqbycvPtS0CpDNbxuNl5&si=p_qyX366EaO_QyNo",
  },
];

const problemSeries = [
  {
    title: "コンプライアンス問題動画",
    desc: "令和の今ではもうやれない！社員さん増えたからもうやれない！好感度欲しいからもうやれない！",
    tag: "DANGER",
    tagColor: "bg-[#FF0F0F]",
    img: "https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/91035a8deb543c84e6c337ecaa1ce26b.png",
    rotate: "rotate-1",
    borderColor: "border-[#FF0F0F]",
    dangerTape: true,
    url: "https://youtube.com/playlist?list=PLEvleHvb7Eg_q4Ju_kLvp1YA4ojefZ6iS&si=2PMOVtbp0GnzfA5c",
  },
];

interface SeriesItem {
  title: string;
  desc: string;
  tag: string;
  tagColor: string;
  img: string;
  rotate: string;
  borderColor: string;
  dangerTape?: boolean;
  url?: string;
}

function useScrollAnim() {
  useEffect(() => {
    const els = document.querySelectorAll(".anim-fade-up, .anim-fade-left, .anim-fade-right, .anim-scale-in");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
          }
        });
      },
      { threshold: 0.1 }
    );
    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
}

function PolaroidCard({ item, delay = 0 }: { item: SeriesItem; delay?: number }) {
  const handleClick = () => {
    if (item.url) {
      window.open(item.url, "_blank", "noopener,noreferrer");
    }
  };
  return (
    <div
      onClick={handleClick}
      className={`bg-white border-4 ${item.borderColor} p-3 pb-8 ${item.rotate} hover:rotate-0 hover:-translate-y-2 transition-all duration-300 cursor-pointer anim-scale-in card-shine`}
      style={{ boxShadow: "4px 4px 0px #000", transitionDelay: `${delay}ms` }}
    >
      <div className="relative overflow-hidden w-full" style={{ height: "190px" }}>
        <img src={item.img} alt={item.title} className="w-full h-full object-cover object-top" />
        {item.dangerTape && (
          <>
            <div className="absolute inset-0 flex items-center justify-center">
              <div
                className="w-full py-2 bg-[#FFD700] text-black font-black text-center text-sm tracking-widest rotate-12"
                style={{ boxShadow: "0 2px 0 #000" }}
              >
                ⚠️ DANGER ⚠️ DANGER ⚠️ DANGER ⚠️
              </div>
            </div>
            <div className="absolute top-2 right-2 bg-[#FF0F0F] text-white font-black text-xs px-2 py-1 rounded border-2 border-black">
              !炎上注意!
            </div>
          </>
        )}
        <div className={`absolute top-2 left-2 ${item.tagColor} text-white font-black text-xs px-2 py-1 rounded-full border-2 border-black`}>
          {item.tag}
        </div>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity bg-black/40">
          <div className="bg-[#FFD700] text-black font-black text-xs px-3 py-1.5 rounded-full border-2 border-black">
            動画を見る ▶
          </div>
        </div>
      </div>
      <div className="mt-3 px-1">
        <p className="font-black text-sm text-black mb-1">■ {item.title}</p>
        <p className="text-gray-600 text-xs font-bold leading-relaxed">{item.desc}</p>
      </div>
    </div>
  );
}

interface CategorySectionProps {
  label: string;
  labelBg: string;
  labelTextColor: string;
  borderColor: string;
  shadowColor: string;
  items: SeriesItem[];
  rightLabel?: string;
  rightLabelBg?: string;
  extraContent?: React.ReactNode;
}

function CategorySection({ label, labelBg, labelTextColor, borderColor, shadowColor, items, rightLabel, rightLabelBg, extraContent }: CategorySectionProps) {
  return (
    <div className="mb-16 anim-fade-up">
      <div className={`border-4 ${borderColor} rounded-3xl p-6 md:p-10 relative bg-white`}
        style={{ boxShadow: `8px 8px 0px ${shadowColor}` }}>
        <div className="absolute -top-5 left-8">
          <div className={`${labelBg} ${labelTextColor} font-black text-base px-5 py-2 rounded-full border-4 border-black`}>
            {label}
          </div>
        </div>
        {rightLabel && rightLabelBg && (
          <div className="absolute -top-5 right-8">
            <div className={`${rightLabelBg} text-black font-black text-sm px-4 py-2 rounded-full border-4 border-black`}>
              {rightLabel}
            </div>
          </div>
        )}
        <div className="mt-4">
          {extraContent ? (
            <div className="flex flex-col md:flex-row items-start gap-8">
              <div className="w-full md:w-80">
                {items.map((item, i) => <PolaroidCard key={i} item={item} delay={i * 100} />)}
              </div>
              {extraContent}
            </div>
          ) : (
            <div className={`grid grid-cols-1 sm:grid-cols-2 ${items.length === 3 ? "lg:grid-cols-3" : "lg:grid-cols-2"} gap-8`}>
              {items.map((item, i) => <PolaroidCard key={i} item={item} delay={i * 120} />)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default function VideoSeries() {
  useScrollAnim();

  return (
    <section id="videos" className="py-20 bg-white relative overflow-hidden">
      <img
        src="https://storage.readdy-site.link/project_files/b4049c21-524e-4360-bd0f-e8c5b9d42418/6d009de2-0cdd-4f77-9bff-2fba95293f0a_unnamed.png?v=cd3ddb1967dc6b2bbbf24d2aad7f1484"
        alt=""
        className="absolute top-8 right-6 w-28 md:w-40 opacity-80 pointer-events-none animate-float-slow"
        style={{ "--rot": "12deg" } as React.CSSProperties}
      />
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-16 anim-fade-up">
          <div className="inline-block bg-black text-white font-black text-sm px-6 py-2 rounded-full mb-4 tracking-widest">
            CONTENTS
          </div>
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-black text-black whitespace-nowrap">
            トラックボーイズの<span className="text-[#0066FF]">動画</span>
          </h2>
          <p className="text-gray-500 font-bold mt-2">どんな動画があるの？一部紹介します！</p>
        </div>

        {/* 人気動画 */}
        <CategorySection
          label="🌟 人気動画"
          labelBg="bg-[#0066FF]"
          labelTextColor="text-white"
          borderColor="border-[#0066FF]"
          shadowColor="#0066FF"
          items={popularSeries}
        />

        {/* おすすめ動画 */}
        <CategorySection
          label="👍 おすすめ動画"
          labelBg="bg-[#00B050]"
          labelTextColor="text-white"
          borderColor="border-[#00B050]"
          shadowColor="#00B050"
          items={recommendedSeries}
        />

        {/* エンタメ動画 */}
        <CategorySection
          label="🎉 エンタメ動画"
          labelBg="bg-[#FFD700]"
          labelTextColor="text-black"
          borderColor="border-[#FFD700]"
          shadowColor="#FFD700"
          items={entertSeries}
        />

        {/* 問題動画 */}
        <CategorySection
          label="⚠️ 問題動画"
          labelBg="bg-[#FF0F0F]"
          labelTextColor="text-white"
          borderColor="border-[#FF0F0F]"
          shadowColor="#FF0F0F"
          items={problemSeries}
          rightLabel="閲覧注意"
          rightLabelBg="bg-[#FFD700]"
          extraContent={
            <div className="flex-1 flex items-center">
              <div className="bg-[#FFF3F3] border-4 border-[#FF0F0F] rounded-2xl p-6">
                <p className="text-[#FF0F0F] font-black text-xl mb-3">⚡ DANGER ZONE ⚡</p>
                <p className="font-bold text-gray-700 leading-relaxed text-base">
                  マッチングアプリやってる上司とマッチングしてみたドッキリ、女性セラピストだと思っていたら男だったドッキリ、もしも運送会社が夜の店風だったらコント、など会社に怒られるギリギリを攻めた動画たち。（怒られました）
                </p>
                <p className="mt-3 text-gray-500 font-bold text-sm">
                  ※ほっこり系がお好みの方は見ない事を強くお勧めします！
                </p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {["#炎上", "#コメント欄見たくない", "#時代に合わない"].map((tag) => (
                    <span key={tag} className="bg-black text-white font-black text-xs px-3 py-1 rounded-full">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          }
        />
      </div>
    </section>
  );
}
